import QuickFinderVM from './quick-finder-vm';
var self = this;

export default {
  init: function(){
    console.log('Initializing AdminQuickFinder');
    var validationOptions = Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS;
    var ele = document.getElementById('quickfind');
    ko.applyBindingsWithValidation(new QuickFinderVM(ele), ele, validationOptions);
  }
};

